import PageImage from "./PageImage";

export default PageImage;
